import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import { cn } from '../../../../../lib/utils';

function ConfirmModal({ isOpen, onClose, onConfirm, title, message, changes }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div
        className="relative bg-background rounded-lg shadow-lg p-6 w-full max-w-md mx-4"
        style={{ border: '1px solid hsl(var(--border))' }}
      >
        <div className="flex items-start gap-4">
          <div className="p-2 rounded-full bg-amber-500/10">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground">{title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{message}</p>
          </div>
        </div>

        {/* Changes List */}
        {changes && changes.length > 0 && (
          <div className="mt-4 space-y-2">
            {changes.map((change) => (
              <div
                key={change.field}
                className="flex items-center gap-2 p-3 rounded-md bg-muted/50"
              >
                <span className="text-sm font-medium text-muted-foreground w-24">
                  {change.field}:
                </span>
                <span
                  className={cn(
                    'px-2 py-0.5 rounded text-xs font-medium',
                    'bg-red-500/10 text-red-600',
                  )}
                >
                  {change.from || '-'}
                </span>
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
                <span
                  className={cn(
                    'px-2 py-0.5 rounded text-xs font-medium',
                    'bg-green-500/10 text-green-600',
                  )}
                >
                  {change.to || '-'}
                </span>
              </div>
            ))}
          </div>
        )}

        <div className="flex justify-end gap-3 mt-6">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Confirm</Button>
        </div>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      from: PropTypes.string,
      to: PropTypes.string,
    }),
  ),
};

ConfirmModal.defaultProps = {
  changes: null,
};

export default ConfirmModal;
